import { render, staticRenderFns } from "./NotificheTimeline.vue?vue&type=template&id=e4b4c318&scoped=true&"
import script from "./NotificheTimeline.vue?vue&type=script&lang=js&"
export * from "./NotificheTimeline.vue?vue&type=script&lang=js&"
import style0 from "./NotificheTimeline.vue?vue&type=style&index=0&id=e4b4c318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b4c318",
  null
  
)

export default component.exports